varying vec3 vposition;
varying vec2 vUv;
uniform float uTime;
varying vec3 vNormal;
void main()
{
  vec3 normal = normalize(vNormal);
  float stripes=mod((vposition.y- uTime * .02) * 10.,1.0);
  stripes=pow(stripes,3.0);
  vec3 viewDirection = normalize(vposition - cameraPosition);
  float fresnel =  dot(viewDirection, normal)+ 1. ;
      // fresnel = pow(fresnel, 2.0);
    // Final color
    gl_FragColor = vec4(sin(uTime*.9),sin(uTime*.1),cos(uTime*.8),  fresnel);
}
